module.exports = __webpack_public_path__ + "media/images/flags/SX-336a0da50f337f48ab6a2902272cb5dd.svg";